import { FormElement } from 'app/containers/types';

export interface ResponseError {
  message: string;
}
export type RequestError = ResponseError;

export type AllocatedUsers = {
  id: string|null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  mobileNumber: string | null;
};

export type PropertyListItemType = {
  id: string;
  address: string | null;
  zipCode: Number | null;
  state: string | null;
  city: string | null;
  type: string | null;
  occupationStatus: string | null;
  propertyStatus: string | null;
  email: string | null;
  // isActive: boolean;
  // role: string | null;
  // createdAt: string | null;
  // updatedAt: string | null;
  // blockedUntil: string | null;
};

export interface NewPropertyRequest {
  address: string | null;
  zipCode: Number | null;
  state: string | null;
  city: string | null;
  type: string | null;
  occupationStatus: string | null;
  propertyStatus: string | null;
  email: string | null;
  isActive: boolean;
}

export type NewUserResponse = {
  id: any;
  address: string | null;
  zipCode: Number | null;
  state: string | null;
  city: string | null;
  type: string | null;
  occupationStatus: string | null;
  propertyStatus: string | null;
  blockedUntil: string | null;
  email: string;
  isActive: true;
  role: any;
  image: any;
  userType: string;
  createdAt: string;
  updatedAt: string;
  message?: string;
};

export type PropertyForm = {
  id: FormElement;
  address: FormElement;
  zipCode: FormElement;
  state: FormElement;
  city: FormElement;
  type: FormElement;
  occupationStatus: FormElement;
  propertyStatus: FormElement;
  email: FormElement;
  isActive: FormElement;
  role: FormElement;
  createdAt: FormElement;
  updatedAt: FormElement;
  blockedUntil: FormElement;
};

export type PropertyStateType = {
  impressionsQuery: {
    skip: number;
    limit: number;
    // q: string;
    // status: string;
    // orderField: string;
    // orderDirection: string;
    userId: string;
    impressionableId: string;
  };
  postsQuery: {
    page: number;
    limit: number;
    q: string;
    status: string;
    orderField: string;
    orderDirection: string;
    userId: string;
  };
  query: {
    limit: number;
    page: number;
    distributorId: string;
    user_type: string;
    q: string;
    orderField: string;
    orderDirection: string;
    createMin: string;
    createMax: string;
    updateMin: string;
    updateMax: string;
  };
  form: {
    property: PropertyForm;
  };
  list: {
    items: Array<PropertyListItemType>;
    meta: {
      totalItems: number;
      itemCount: number;
      itemsPerPage: number;
      totalPages: number;
      currentPage: number;
    };
    links: {
      first: string;
      last: string;
      previous: string;
      next: string;
    };
  };
  loading: boolean;
  error: string;
  links: {
    first: string | null,
    previous: string | null,
    next: string | null,
    last: string | null,
  },
  allocatedUsers:Array<AllocatedUsers>;
  editModal: boolean;
};

export const PropertyState: PropertyStateType = {
  impressionsQuery: {
    userId: '',
    skip: 0,
    limit: 10,
    impressionableId: '',
  },
  postsQuery: {
    userId: '',
    page: 1,
    q: '',
    limit: 10,
    orderDirection: '',
    orderField: '',
    status: '',
  },
  query: {
    user_type: '',
    distributorId: '',
    limit: 15,
    page: 1,
    q: '',
    orderField: '',
    orderDirection: '',
    updateMax: '',
    updateMin: '',
    createMax: '',
    createMin: '',
  },
  links: {
    first: '',
    previous: '',
    next: '',
    last: '',
  },
  list: {
    items: [],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: '',
      previous: '',
      next: '',
      last: '',
    },
  },
  loading: false,
  form: {
    property: {
      id: { value: '' },
      address: { value: '' },
      zipCode: { value: 0 },
      state: { value: '' },
      city: { value: '' },
      type: { value: '' },
      occupationStatus: { value: '' },
      propertyStatus: { value: '' },
      email: { value: '' },
      isActive: { value: '' },
      role: { value: '' },
      createdAt: { value: '' },
      updatedAt: { value: '' },
      blockedUntil: { value: '' },
    },
  },
  error: '',
  allocatedUsers:[],
  editModal: false,
};

export type ContainerState = PropertyStateType;
